import { Button, Col, Modal, Row, Space, Typography } from 'antd';
import React from 'react';

import { WEEK_DAYS_MON_START } from '@/constants/date';

import { MODAL_BODY_STYLES } from '../../constants';
import { getOpeningHours } from '../../helpers';
import type { VenueDetailData } from '../../types';

const { Text } = Typography;

type DetailModalProps = {
  open: boolean;
  onClose: () => void;
  venue: VenueDetailData | undefined;
};

export const DetailModal = ({ open, onClose, venue }: DetailModalProps) => {
  if (!venue) return null;

  return (
    <Modal
      title="空間清單"
      open={open}
      centered
      destroyOnClose
      onCancel={onClose}
      bodyStyle={MODAL_BODY_STYLES}
      footer={[
        <Button key="ok" onClick={onClose}>
          確認
        </Button>,
      ]}
    >
      <Space direction="vertical" size="large" className="w-full">
        <Space direction="vertical" className="w-full">
          <Text type="secondary">活動空間名稱</Text>
          <Text>{venue.name}</Text>
        </Space>
        <Space direction="vertical" className="w-full">
          <Text type="secondary">地址</Text>
          <Text>{venue.address}</Text>
        </Space>
        <Space direction="vertical" className="w-full">
          <Text type="secondary">容納人數</Text>
          <Text>{venue.capacity}</Text>
        </Space>
        <Space direction="vertical" className="w-full">
          <Text type="secondary">開放時間</Text>
          {venue.operatingHours.map(({ day, ...operatingHoursInfo }) => {
            const openingHours = getOpeningHours(operatingHoursInfo);
            const isArray = Array.isArray(openingHours);
            return (
              <Row key={day}>
                <Col flex={2}>
                  <Text>{`星期${WEEK_DAYS_MON_START[day]}：`}</Text>
                </Col>

                {isArray ? (
                  <Col flex={3}>
                    <Space direction="vertical" className="w-full">
                      {openingHours.map((timePeriod, index) => {
                        return <Text key={index}>{timePeriod}</Text>;
                      })}
                    </Space>
                  </Col>
                ) : (
                  <Col flex={3}>{openingHours}</Col>
                )}
              </Row>
            );
          })}
        </Space>
      </Space>
    </Modal>
  );
};
